import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
 
import { ButtonConfirmed } from '../../Button'
import { AutoRow, RowBetween } from '../../Row'
import Loader from '../../Loader'

import { stopPropagation } from '../../../utils/func'
import { useActiveWeb3React } from '../../../hooks'
import { auditArtworks } from '../../../service/nft'


const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
`

export default function AuditBtn ({artwork}: {artwork: any}) {
  const { library, account, chainId } = useActiveWeb3React()

  // 确认审核
  const [requestedRefuse, setRequestedRefuse] = useState(false)
  const [requestedApprove, setRequestedApprove] = useState(false)
  const onAudit = useCallback(async (event, type) => {
    stopPropagation(event)
    if (!library) return
    if (type === 'refuse') {
      setRequestedRefuse(true)
    } else {
      setRequestedApprove(true)
    }
    let time = Math.round(new Date().getTime()/1000).toString()
    library
      .send('eth_sign', [account, (artwork.tokenId + '-' + time)])
      .then(signature => {
        let param = {
          nftType: artwork.nftType,
          address: account,
          timestamp: time,
          nftId: artwork.tokenId,
          status: type === 'refuse' ? -1 : 1,
          signature: signature
        }
        auditArtworks(chainId as number, param, (err: any, d: any) => {
          setRequestedRefuse(false)
          setRequestedApprove(false)
          if (err) return
          if (d.code !== 0) return
        })
      })
      .catch(error => {
        setRequestedRefuse(false)
        setRequestedApprove(false)
        console.log('err', error)
      })
  }, [library, account, chainId, artwork])

  return (
    <RowBetween>
      <Button
        onClick={event => onAudit(event, 'refuse')}
        disabled={requestedRefuse}
        marginRight="15px">
        {
          requestedRefuse ? (
            <AutoRow gap="6px" justify="center">
              Pending <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Refuse'
          )
        }
      </Button>
      <Button
        onClick={event => onAudit(event, 'approve')}
        disabled={requestedApprove}>
        {
          requestedApprove ? (
            <AutoRow gap="6px" justify="center">
              Pending <Loader stroke="white" />
            </AutoRow>
          ) : (
            'Approve'
          )
        }
      </Button>
    </RowBetween>
  )
}